/**
 * Created by sxp23 on 1/18/2018.
 */
import { Component, OnInit, AfterViewInit, OnDestroy } from "@angular/core";
import { Subscription } from "rxjs";

import * as L from "leaflet";
import * as esri from "esri-leaflet";
import booleanPointInPolygon from "@turf/boolean-point-in-polygon";

import { CommonService } from "../common.service";
import { SharedService } from "../shared.service";

@Component({
  selector: "nys-map",
  templateUrl: "./map.component.html",
  styleUrls: ["./map.component.css"],
})
export class MapComponent implements OnInit, AfterViewInit, OnDestroy {
  homeLat: any;
  homeLng: any;
  homeAdr: string;
  subscription: Subscription;

  nysMap; // = L.Map;
  dohPWSLayerGroup1;
  dohPWSLayerGroup2;
  dohPWSLayerGroup3;
  layersControl;

  homeMarker;
  homeCircle;
  mobile;
  showOrHide = "Hide";
  dohMarkers = [];
  dohLayerGroup;
  selectedPWSLat;
  selectedPWSLng;
  noAddress = false;

  baseMaps = {
    Topographic: esri.basemapLayer("Topographic"),
    Satellite: L.layerGroup([
      esri.basemapLayer("Imagery"),
      esri.basemapLayer("ImageryLabels"),
    ]),
    Streets: esri.basemapLayer("Streets"),
    "National Geographic": esri.basemapLayer("NationalGeographic"),
  };
  options = {
    zoom: 10,
    center: L.latLng(42.736424, -75.762713), //42.652580,-73.756233),
    doubleClickZoom: false,
    attributionControl: false,
    minZoom: 7,
    maxZoom: 18,
    maxBounds: new L.LatLngBounds(
      new L.LatLng(40.1, -79.79),
      new L.LatLng(45.5, -71.7)
    ), //South,west  , north,east
  };

  constructor(
    private commonService: CommonService,
    private sharedService: SharedService
  ) {
    this.subscription = sharedService.homeAddress$.subscribe((addres) => {
      var locHref = location.href;
      if (
        addres &&
        locHref.substr(locHref.lastIndexOf("/")) === "/waterSystems"
      ) {
        var selectedPwsId;
        var address = JSON.parse(addres);
        if (address.text && address.magicKey) {
          this.commonService
            .getLngLatForAddress(address.text, address.magicKey)
            .subscribe(
              (addres) => {
                //console.log("address", addres, 22, addres.candidates[0], 33, addres.candidates[0].address, 44, addres.candidates[0].location);
                this.homeLat = addres.candidates[0].location.y;
                this.homeLng = addres.candidates[0].location.x;
                this.homeAdr = addres.candidates[0].address;
              },
              (err) =>
                console.error(
                  "Error in getLngLatForAddress() at Water System Map::",
                  err
                ),
              () => {
                //Finally block
                this.nysMap.removeLayer(this.homeMarker);
                this.nysMap.removeLayer(this.homeCircle);
                var localThis = this;
                try {
                  this.homeMarker = L.marker([this.homeLat, this.homeLng], {
                    //marker for home address
                    icon: L.icon({
                      iconAnchor: [9, 18],
                      popupAnchor: [0, -18],
                      iconUrl: "assets/images/home3.png",
                    }),
                  });
                  if (this.dohPWSLayerGroup1) {
                    this.dohPWSLayerGroup1.eachLayer(function (layer) {
                      if (
                        booleanPointInPolygon(
                          localThis.homeMarker.toGeoJSON(),
                          layer.toGeoJSON()
                        )
                      ) {
                        selectedPwsId = layer.feature.properties.PWS_Number;
                      }
                    });
                  }
                  if (this.dohPWSLayerGroup2 && !selectedPwsId) {
                    this.dohPWSLayerGroup2.eachLayer(function (layer) {
                      if (
                        booleanPointInPolygon(
                          localThis.homeMarker.toGeoJSON(),
                          layer.toGeoJSON()
                        )
                      ) {
                        selectedPwsId = layer.feature.properties.PWS_Number;
                      }
                    });
                  }
                  if (this.dohPWSLayerGroup3 && !selectedPwsId) {
                    this.dohPWSLayerGroup3.eachLayer(function (layer) {
                      if (
                        booleanPointInPolygon(
                          localThis.homeMarker.toGeoJSON(),
                          layer.toGeoJSON()
                        )
                      ) {
                        selectedPwsId = layer.feature.properties.PWS_Number;
                      }
                    });
                  }
                } catch (err) {
                  console.log(
                    "Error at Address Change constructor at DOH Map",
                    err
                  );
                } finally {
                  this.commonService
                    .getDOHMapPWS(this.homeLat, this.homeLng)
                    .subscribe(
                      (pwsMapdata) => {
                        if (!selectedPwsId) {
                          this.selectedPWSLat = pwsMapdata[0].latitude;
                          this.selectedPWSLng = pwsMapdata[0].longitude;
                          selectedPwsId = pwsMapdata[0].pwsId;
                        } else {
                          for (let pwsMap of pwsMapdata) {
                            if (selectedPwsId === pwsMap.pwsId) {
                              this.selectedPWSLat = pwsMap.latitude;
                              this.selectedPWSLng = pwsMap.longitude;
                              if (
                                selectedPwsId !== this.sharedService.getPwsId()
                              )
                                this.sharedService.setPwsId(selectedPwsId);
                            }
                          }
                          if (!this.selectedPWSLat && !this.selectedPWSLng) {
                            this.selectedPWSLat = pwsMapdata[0].latitude;
                            this.selectedPWSLng = pwsMapdata[0].longitude;
                            selectedPwsId = pwsMapdata[0].pwsId;
                          }
                        }
                      },
                      (err) =>
                        console.error("Error in getDOHMapPWS() call::", err),
                      () => {
                        if (this.selectedPWSLat) {
                          this.homeMarker.addTo(this.nysMap);
                          this.homeMarker.bindPopup(
                            "Address : " + this.homeAdr
                          );
                          var dist = 25; // 25 miles,
                          var theRadius = dist * 1609.34; //1609.34 meters in a mile
                          // draw circle to see the selection area
                          this.homeCircle = L.circle(
                            [this.selectedPWSLat, this.selectedPWSLng],
                            theRadius,
                            {
                              /// Number is in Meters
                              fillColor: "#ffffff", //#A3C990
                              color: "#ffffff", //#000
                              weight: 1,
                              opacity: 1,
                              fillOpacity: 0.4,
                              interactive: false,
                            }
                          );
                          this.homeCircle.addTo(this.nysMap);
                          this.homeCircle.bringToBack();
                          //this.nysMap.invalidateSize();
                          setTimeout(() => {
                            if (this.noAddress)
                              this.nysMap.panTo(
                                new L.LatLng(this.homeLat, this.homeLng)
                              );
                            else
                              this.nysMap.panTo(
                                new L.LatLng(
                                  this.selectedPWSLat,
                                  this.selectedPWSLng
                                )
                              );
                          }, 1);
                          if (selectedPwsId) {
                            this.nysMap._layers[selectedPwsId].fire("click");
                            this.nysMap.closePopup();
                          }
                        }
                      }
                    );
                }
              }
            );
        }
      }
    });
    //console.log("this.subscription", this.subscription);
    this.subscription = sharedService.pwsLatLng$.subscribe((pwsLatLn) => {
      //console.log("pwsLatLn in Water System MAP", pwsLatLn);
      if (pwsLatLn) {
        var latLng = JSON.parse(pwsLatLn);
        if (latLng && latLng.latitude) {
          setTimeout(() => {
            //console.log("panTo @ 177", latLng.latitude, latLng.longitude)
            this.nysMap.panTo(new L.LatLng(latLng.latitude, latLng.longitude));
          }, 1);

          this.nysMap._layers[latLng.pwsId].fire("click");
          this.nysMap.closePopup();
        }
      }
    });
  }

  ngOnDestroy() {
    // prevent memory leak when component destroyed
    this.subscription.unsubscribe();
  }

  onMapClick(pwsId, evt) {
    this.nysMap.removeLayer(this.homeCircle);
    var dist = 25; // 25 miles,
    var theRadius = dist * 1609.34; //1609.34 meters in a mile
    // draw circle to see the selection area
    this.homeCircle = L.circle([evt.latlng.lat, evt.latlng.lng], theRadius, {
      /// Number is in Meters
      fillColor: "#ffffff", //#A3C990
      color: "#ffffff", //#000
      weight: 1,
      opacity: 1,
      fillOpacity: 0.4,
      interactive: false,
    });
    this.homeCircle.addTo(this.nysMap);
    this.homeCircle.bringToBack();
    //this.nysMap.invalidateSize();
    setTimeout(() => {
      this.nysMap.panTo(new L.LatLng(evt.latlng.lat, evt.latlng.lng));
    }, 1);

    this.nysMap._layers[pwsId].fire("click");
  }

  ngOnInit() {
    //console.log("sharedService.getHomeAddress()", this.sharedService.getHomeAddress())
    if (window.screen.width < 768) {
      // 768px portrait
      this.mobile = true;
    }
    if (this.sharedService.getHomeAddress()) {
      var address = JSON.parse(this.sharedService.getHomeAddress());
      if (address.text && address.magicKey) {
        this.commonService
          .getLngLatForAddress(address.text, address.magicKey)
          .subscribe(
            (addres) => {
              //console.log("address", addres, 22, addres.candidates[0], 33,addres.candidates[0].address, 44, addres.candidates[0].location);
              this.homeLat = addres.candidates[0].location.y;
              this.homeLng = addres.candidates[0].location.x;
              this.homeAdr = addres.candidates[0].address;
            },
            (err) =>
              console.error(
                "Error in getLngLatForAddress() at Water System Map::",
                err
              ),
            () => {
              //Finally block
              if (!this.homeLat) {
                this.homeLat = 42.736424;
                this.homeLng = -75.762713;
                //this.homeAdr = "Muller Hill State Forest, Georgetown, NY 13072, USA";
                this.homeAdr = "13072, Georgetown, New York";
                this.options.zoom = 10;
                this.noAddress = true;
              }
              this.populateMap();
            }
          );
      }
    } else {
      if (!this.homeLat) {
        this.homeLat = 42.736424;
        this.homeLng = -75.762713;
        //this.homeAdr = "Muller Hill State Forest, Georgetown, NY 13072, USA";
        this.homeAdr = "13072, Georgetown, New York";
        this.options.zoom = 10;
        this.noAddress = true;
      }
      this.populateMap();
    }
  }

  private getIconPWS(r: string): string {
    return r == "PWS Boundary"
      ? "assets/images/pwsBoundary.png"
      : r == "Selected PWS"
      ? "assets/images/GreenBoundary.png"
      : "assets/images/home3Lgnd.png";
  }

  toggleLegend() {
    if (this.showOrHide === "Hide") {
      if (document.getElementById("legendDivPWS")) {
        var elem = document.getElementById("legendDivPWS");
        elem.parentNode.removeChild(elem);
      }
      this.showOrHide = "Show";
    } else {
      this.showOrHide = "Hide";
      this.createLegendsPWS();
      if (this.layersControl) {
        //this.nysMap.removeLayer(this.baseMaps.Topographic);
        this.layersControl.remove(this.nysMap);
      }
      //Add layer control
      this.layersControl = L.control
        .layers(this.baseMaps, null, { position: "topleft" })
        .addTo(this.nysMap);
      this.baseMaps.Topographic.addTo(this.nysMap);
    }
  }

  private populateMap(): void {
    function countyStyle(feature) {
      return {
        interactive: false, // in order to remove hand pointer (Link Select) on County layer
        fillColor: "#B8BF3F", //inside polygon color
        fillOpacity: 0.07, //transparency of fill
        weight: 1, //thickness of outline
        opacity: 1, //transparency of outline
        color: "black", //color of outline
        dashArray: "9", // dash size
      };
    }
    function PWSStyle() {
      return {
        interactive: true, // in order to remove hand pointer (Link Select) on County layer
        fillColor: "#e8db4c", //inside polygon color 3e76bf  3e46bf
        fillOpacity: 0.3, //transparency of fill
        weight: 1, //thickness of outline
        opacity: 1, //transparency of outline
        color: "orange", //color of outline
        dashArray: "1", // dash size
      };
    }
    //console.log("this.homeLat IN populateMap in WATER SYSTEM MAP", this.homeLat, "this.homeLng", this.homeLng, "this.homeAdr",this.homeAdr);
    setTimeout(() => {
      this.nysMap = L.map("NYSMap", this.options);
      var map = this.nysMap;
      var localThis = this;

      var myLayer = L.geoJSON(null, { style: countyStyle }).addTo(this.nysMap);
      this.commonService.getCountyMaps().subscribe(
        (lngLatsdata) => {
          myLayer.addData(lngLatsdata); //.on('click', this.onMapClick);  //this.onMapClick.bind(this)
        },
        (err) => console.error("Error in getCountyMaps() call::", err),
        () => {}
      );

      var highlight = {
        fillColor: "green",
        weight: 2,
        opacity: 1,
      };
      function forEachFeature(feature, layer) {
        // Tagging each PWS poly with their PWS ID for the search control.
        layer._leaflet_id = feature.properties.PWS_Number;
        var popupContent =
          '<div class="table-responsive"><table class="table table-sm table-bordered"><thead><tr><th scope="col" colspan="2">' +
          feature.properties.PWS_Name +
          "</th></tr></thead><tbody><tr>" +
          '<th scope="row">PWS ID</th><td>' +
          feature.properties.PWS_Number +
          "</td></tr><tr>" +
          '<th scope="row">County Served</th><td>' +
          feature.properties.Principal_County_Served +
          "</td></tr><tr>" +
          '<th scope="row">Population Served</th><td>' +
          feature.properties.PopServed +
          "</td></tr><tr>" +
          "</tbody></table></div>";

        layer.bindPopup(popupContent);

        /*layer.on("dblclick", function (e) {
         localThis.dohPWSLayerGroup1.setStyle(PWSStyle); //resets layer colors
         localThis.dohPWSLayerGroup2.setStyle(PWSStyle);
         localThis.dohPWSLayerGroup3.setStyle(PWSStyle);
         layer.setStyle(highlight);  //highlights selected.
         layer.bringToFront();
         });*/
        layer.on("click", function (e) {
          //console.log("e.latlng.lat", e.latlng, feature.properties.PWS_Number, localThis.sharedService.getPwsId())
          if (
            feature.properties.PWS_Number !== localThis.sharedService.getPwsId()
          )
            localThis.sharedService.setPwsId(feature.properties.PWS_Number);
          if (e.latlng && e.latlng.lat) {
            map.removeLayer(localThis.homeCircle);
            var dist = 25; // 25 miles,
            var theRadius = dist * 1609.34; //1609.34 meters in a mile
            // draw circle to see the selection area
            localThis.homeCircle = L.circle(
              [e.latlng.lat, e.latlng.lng],
              theRadius,
              {
                /// Number is in Meters
                fillColor: "#ffffff", //#A3C990
                color: "#ffffff", //#000
                weight: 1,
                opacity: 1,
                fillOpacity: 0.4,
                interactive: false,
              }
            );
            localThis.homeCircle.addTo(map);
            //this.nysMap.invalidateSize();
            setTimeout(() => {
              //console.log("panTo @ 363", e.latlng.lat, e.latlng.lng)
              map.panTo(new L.LatLng(e.latlng.lat, e.latlng.lng));
            }, 1);

            localThis.sharedService.setFlowFlag2Lat(e.latlng.lat);
            localThis.sharedService.setFlowFlag2Lng(e.latlng.lng);
            localThis.sharedService.setLatLngFrESRIMap(null);
          }
          localThis.dohPWSLayerGroup1.setStyle(PWSStyle); //resets layer colors
          localThis.dohPWSLayerGroup2.setStyle(PWSStyle);
          localThis.dohPWSLayerGroup3.setStyle(PWSStyle);
          layer.setStyle(highlight); //highlights selected.
          layer.bringToFront();
        });
      }
      var selectedPwsId; //console.log("this.homeLat, this.homeLng @378", this.homeLat, this.homeLng)
      this.homeMarker = L.marker([this.homeLat, this.homeLng], {
        //marker for home address
        icon: L.icon({
          iconAnchor: [9, 18],
          popupAnchor: [0, -18],
          iconUrl: "assets/images/home3.png",
        }),
      });

      this.dohPWSLayerGroup1 = L.geoJSON(null, {
        onEachFeature: forEachFeature,
        style: PWSStyle,
      });
      this.commonService.getPWSBoundaryMaps1().subscribe(
        (lngLatsdata) => {
          this.dohPWSLayerGroup1.addData(lngLatsdata);
        },
        (err) => console.error("Error in getPWSBoundaryMaps1() call::", err),
        () => {
          this.dohPWSLayerGroup1.addTo(this.nysMap); //console.log(!this.sharedService.getFlowFlag2Lat() , !this.sharedService.getLatLngFrESRIMap(),2222222,this.sharedService.getLatLngFrESRIMap(),this.sharedService.getFlowFlag2Lat(),99,this.sharedService.getPwsId())
          this.dohPWSLayerGroup1.bringToFront();
          if (
            !this.sharedService.getFlowFlag2Lat() &&
            !this.sharedService.getLatLngFrESRIMap()
          ) {
            this.dohPWSLayerGroup1.eachLayer(function (layer) {
              //isInside = inside(localThis.homeMarker.toGeoJSON(), layer.toGeoJSON());
              if (
                booleanPointInPolygon(
                  localThis.homeMarker.toGeoJSON(),
                  layer.toGeoJSON()
                )
              ) {
                //console.log("am inside", layer.feature.properties.PWS_Number);
                selectedPwsId = layer.feature.properties.PWS_Number;
              }
            });
          }

          this.dohPWSLayerGroup2 = L.geoJSON(null, {
            onEachFeature: forEachFeature,
            style: PWSStyle,
          });
          this.commonService.getPWSBoundaryMaps2().subscribe(
            (lngLatsdata) => {
              this.dohPWSLayerGroup2.addData(lngLatsdata);
            },
            (err) =>
              console.error("Error in getPWSBoundaryMaps2() call::", err),
            () => {
              this.dohPWSLayerGroup2.addTo(this.nysMap);
              this.dohPWSLayerGroup2.bringToFront();
              if (
                !this.sharedService.getFlowFlag2Lat() &&
                !this.sharedService.getLatLngFrESRIMap()
              ) {
                this.dohPWSLayerGroup2.eachLayer(function (layer) {
                  if (
                    booleanPointInPolygon(
                      localThis.homeMarker.toGeoJSON(),
                      layer.toGeoJSON()
                    )
                  ) {
                    //console.log("am inside2", layer.feature.properties.PWS_Number);
                    selectedPwsId = layer.feature.properties.PWS_Number;
                  }
                });
              }
              this.dohPWSLayerGroup3 = L.geoJSON(null, {
                onEachFeature: forEachFeature,
                style: PWSStyle,
              });
              this.commonService.getPWSBoundaryMaps3().subscribe(
                (lngLatsdata) => {
                  this.dohPWSLayerGroup3.addData(lngLatsdata);
                },
                (err) =>
                  console.error("Error in getPWSBoundaryMaps3() call::", err),
                () => {
                  this.dohPWSLayerGroup3.addTo(this.nysMap);
                  this.dohPWSLayerGroup3.bringToFront();
                  if (
                    !this.sharedService.getFlowFlag2Lat() &&
                    !this.sharedService.getLatLngFrESRIMap()
                  ) {
                    this.dohPWSLayerGroup3.eachLayer(function (layer) {
                      if (
                        booleanPointInPolygon(
                          localThis.homeMarker.toGeoJSON(),
                          layer.toGeoJSON()
                        )
                      ) {
                        //console.log("am inside3", layer.feature.properties.PWS_Number);
                        selectedPwsId = layer.feature.properties.PWS_Number;
                      }
                    });
                  }
                  this.commonService
                    .getDOHMapPWS(this.homeLat, this.homeLng)
                    .subscribe(
                      (pwsMapdata) => {
                        if (this.sharedService.getLatLngFrESRIMap()) {
                          var latLngFrESRI = JSON.parse(
                            this.sharedService.getLatLngFrESRIMap()
                          );
                          this.selectedPWSLat = latLngFrESRI.lat;
                          this.selectedPWSLng = latLngFrESRI.lng;
                          selectedPwsId = latLngFrESRI.pwsId;
                          //this.sharedService.setLatLngFrESRIMap(null);
                        } else if (
                          this.sharedService.getPwsId() &&
                          this.sharedService.getFlowFlag2Lat()
                        ) {
                          selectedPwsId = this.sharedService.getPwsId();
                          this.selectedPWSLat =
                            this.sharedService.getFlowFlag2Lat();
                          this.selectedPWSLng =
                            this.sharedService.getFlowFlag2Lng();
                          //this.sharedService.setPwsId(selectedPwsId);
                        } else if (
                          !selectedPwsId &&
                          !this.sharedService.getFlowFlag2Lat()
                        ) {
                          this.selectedPWSLat = pwsMapdata[0].latitude;
                          this.selectedPWSLng = pwsMapdata[0].longitude;
                          selectedPwsId = pwsMapdata[0].pwsId;
                        } else {
                          for (let pwsMap of pwsMapdata) {
                            if (selectedPwsId === pwsMap.pwsId) {
                              this.selectedPWSLat = pwsMap.latitude;
                              this.selectedPWSLng = pwsMap.longitude;
                            }
                          }
                        }
                        if (selectedPwsId) {
                          // && selectedPwsId!==this.sharedService.getPwsId()) {
                          this.sharedService.setPwsId(selectedPwsId);
                        }
                      },
                      (err) =>
                        console.error("Error in getDOHMapPWS() call::", err),
                      () => {
                        this.dohLayerGroup = L.layerGroup(this.dohMarkers);
                        this.dohLayerGroup.addTo(this.nysMap);

                        this.homeMarker.addTo(this.nysMap);
                        this.homeMarker.bindPopup("Address : " + this.homeAdr);
                        var dist = 25; // 25 miles,
                        var theRadius = dist * 1609.34; //1609.34 meters in a mile
                        // draw circle to see the selection area
                        if (this.selectedPWSLat && this.selectedPWSLng) {
                          this.homeCircle = L.circle(
                            [this.selectedPWSLat, this.selectedPWSLng],
                            theRadius,
                            {
                              /// Number is in Meters
                              fillColor: "#ffffff", //#A3C990
                              color: "#ffffff", //#000
                              weight: 1,
                              opacity: 1,
                              fillOpacity: 0.4,
                              interactive: false,
                            }
                          );
                          this.homeCircle.addTo(this.nysMap);
                          this.homeCircle.bringToBack();
                        }
                        this.dohLayerGroup = L.layerGroup(this.dohMarkers);
                        this.dohLayerGroup.addTo(this.nysMap);

                        this.nysMap.invalidateSize();
                        setTimeout(() => {
                          //console.log("panTo @ 500", this.selectedPWSLat, this.selectedPWSLng)
                          if (this.noAddress)
                            this.nysMap.panTo(
                              new L.LatLng(this.homeLat, this.homeLng)
                            );
                          else if (this.selectedPWSLat && this.selectedPWSLng) {
                            this.nysMap.panTo(
                              new L.LatLng(
                                this.selectedPWSLat,
                                this.selectedPWSLng
                              )
                            );
                          }
                        }, 1);

                        if (this.nysMap._layers[selectedPwsId]) {
                          this.nysMap._layers[selectedPwsId].fire("click");
                          this.nysMap.closePopup();
                        }
                      }
                    );
                }
              );
            }
          );
        }
      );

      var ZoomViewer = L.Control.extend({
        //position: 'topleft', not working
        onAdd: function () {
          var gauge = L.DomUtil.create("div");
          gauge.style.width = "105px";
          gauge.style.background = "#58ACFA";
          gauge.style.border = "1px solid black";
          gauge.style.textAlign = "center";
          gauge.innerHTML =
            '<div><b><span style="color:black;font-size:110%;">Zoom Level: ' +
            map.getZoom() +
            "</span></b></div>";
          map.on("zoomend", function (ev) {
            gauge.innerHTML =
              '<div><b><span style="color:black;font-size:110%;">Zoom Level: ' +
              map.getZoom() +
              "</span></b></div>";
          });
          return gauge;
        },
      });
      new ZoomViewer().addTo(this.nysMap);

      this.createLegendsPWS();

      map.zoomControl.remove();
      //add zoom control back in but in the upper right
      L.control.zoom({ position: "topright" }).addTo(map);

      //Add layer control
      this.layersControl = L.control
        .layers(this.baseMaps, null, { position: "topleft" })
        .addTo(this.nysMap);
      this.baseMaps.Topographic.addTo(this.nysMap);

      L.control.scale().addTo(this.nysMap);
      //this.showExpandMap()
    }, 1);
  }

  private createLegendsPWS(): void {
    if (this.showOrHide === "Hide") {
      let legend = new L.Control({ position: "topleft" });
      let div;
      if (document.getElementById("legendDivPWS")) {
        var elem = document.getElementById("legendDivPWS");
        elem.parentNode.removeChild(elem);
      }
      div = L.DomUtil.create("div", "info legend");
      div.setAttribute("id", "legendDivPWS");
      legend.onAdd = (map) => {
        let labelsList = [];
        labelsList = ["PWS Boundary", "Selected PWS"];
        var labels = [];
        labels.push("<b>Public Water System</b>"); //Legend Title  pwsBoundary.png
        for (let i = 0; i < labelsList.length; i++) {
          div.innerHTML += labels.push(
            '<img src="' +
              this.getIconPWS(labelsList[i]) +
              '">&nbsp;&nbsp;' +
              (labelsList[i] ? labelsList[i] : "+")
          );
        }
        div.innerHTML = labels.join("<br>");
        return div;
      };
      legend.addTo(this.nysMap);
    }
  }
  private createLegendProcessing(): void {
    let legend = new L.Control({ position: "topright" });
    let div;
    if (document.getElementById("legendDivSpin")) {
      var elem = document.getElementById("legendDivSpin");
      elem.parentNode.removeChild(elem);
    }
    div = L.DomUtil.create("div", "infoj legendj");
    div.setAttribute("id", "legendDivSpin");
    legend.onAdd = (map) => {
      div.innerHTML =
        '<img src="/doh7/waterqual/assets/images/spinner.gif" class="halfsize">';
      return div;
    };
    legend.addTo(this.nysMap);
  }

  private showExpandMap(): void {
    let legend = new L.Control({ position: "bottomright" });
    let div;
    div = L.DomUtil.create("div", "infoj legendj");
    div.setAttribute("id", "legendDivExp");
    legend.onAdd = (map) => {
      div.innerHTML =
        '<a (click)="this.goInteractiveMap()"> <img src="/assets/images/expand1.png"/></a>';
      return div;
    };
    legend.addTo(this.nysMap);
  }

  ngAfterViewInit() {
    if (this.nysMap) {
      this.nysMap.on("layeradd", (e) => {
        this.createLegendProcessing();
        setTimeout(() => {
          if (document.getElementById("legendDivSpin")) {
            var elem = document.getElementById("legendDivSpin");
            elem.parentNode.removeChild(elem);
          }
        }, 2000);
      });
    }
  }
}
